import { css } from 'lit';

export const navStyles = css`
  a {
    font-family: var(--serif-font);
    margin: .4em 0;
    padding: .3em 0;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    vertical-align: baseline;
    white-space: nowrap;
  }
`